module.exports = __webpack_public_path__ + "static/media/lv_mob_r.48ebf067.png";